import React from 'react';
import PropTypes from 'prop-types';
import UserProp from '../../../commonComponents/propTypes/userProp';
import StripeCardProp from '../propTypes/StripeCardProp';
import {
  IN_APP_PRODUCT_TYPE,
  PROFILE_TAB,
  PROFILE_TABS,
} from '../../../services/utilityFunctions';
import CountryProp from '../../../commonComponents/forms/Address/CountryProp';
import HardSkillProp from '../../challenges/propTypes/hardSkillProp';
import TrophyProp from '../../journey/propTypes/trophyProp';
import PerformanceProp from '../propTypes/performanceProp';
import CertificateProp from '../../academy/propTypes/certificateProp';
import AppProductProp from '../propTypes/appProductProp';
import Performance from './Performance';
import Print from './print/Print';
import InfoForm from './forms/InfoForm';
import CompanyForm from './forms/CompanyForm';
import CareerForm from './forms/CareerForm';
import ExperiencesForm from './forms/ExperienceForm';
import HobbiesForm from './forms/HobbiesForm';
import SoftSkillsForm from './forms/SoftSkillsForm';
import LanguagesForm from './forms/LanguagesForm';
import ContactsForm from './forms/ContactsForm';
import MoodsForm from './forms/MoodsForm';
import MediaForm from './forms/MediaForm';
import SocialMediaForm from './forms/SocialMediaForm';
import LegalFinancesForm from './forms/legalFinances/LegalFinancesForm';
import PaymentForm from './forms/PaymentForm';
import SettingsForm from './forms/SettingsForm';
import HardSkills from './hardSkills/HardSkills';
import CurrencyProp from '../propTypes/currencyProp';
import VatTypesProp from '../../../commonComponents/forms/Address/VatTypesProp';
import TabAvailability from './forms/availability/TabAvailability';
import AddressProp from '../../../commonComponents/propTypes/addressProp';
import DocumentsPanel from './documents/DocumentsPanel';
import TabDocuments from './documents/TabDocuments';
import organizationProp from '../../../commonComponents/propTypes/organizationProp';
import Connectors from './connectors/Connectors';

const MainPanel = React.forwardRef((props, ref) => {
  const {
    activeTab,
    member,
    onMemberChange,
    cards,
    countries,
    availableCountries,
    vatTypes,
    languages,
    allLanguages,
    currencies,
    hardSkills,
    onCardsChange,
    stats,
    customTrophies,
    certificates,
    appProducts,
    userLang,
    _csrf,
    directSellingActive,
    workplaceLocations,
    previousUserPageName,
    organizationCompetenciesDomains,
    organization,
    isInJourney,
    onSkipStep,
  } = props;

  const tabs = {
    [PROFILE_TAB.INFO]: (
      <InfoForm
        member={member}
        onMemberChange={onMemberChange}
        countries={countries}
        directSellingActive={directSellingActive}
        previousUserPageName={previousUserPageName}
        onSkipStep={onSkipStep}
      />
    ),
    [PROFILE_TAB.COMPANY]: (
      <CompanyForm
        member={member}
        onMemberChange={onMemberChange}
        workplaceLocations={workplaceLocations}
        onSkipStep={onSkipStep}
      />
    ),
    [PROFILE_TAB.CAREER]: (
      <CareerForm
        member={member}
        onMemberChange={onMemberChange}
        onSkipStep={onSkipStep}
      />
    ),
    [PROFILE_TAB.EXPERIENCE]: (
      <ExperiencesForm
        member={member}
        onMemberChange={onMemberChange}
        organizationCompetenciesDomains={organizationCompetenciesDomains}
        onSkipStep={onSkipStep}
      />
    ),
    [PROFILE_TAB.HOBBIES]: (
      <HobbiesForm
        member={member}
        onMemberChange={onMemberChange}
        onSkipStep={onSkipStep}
      />
    ),
    [PROFILE_TAB.SOFT_SKILLS]: (
      <SoftSkillsForm
        member={member}
        onMemberChange={onMemberChange}
        languages={allLanguages}
        onSkipStep={onSkipStep}
      />
    ),
    [PROFILE_TAB.HARD_SKILLS]: (
      <HardSkills
        member={member}
        onMemberChange={onMemberChange}
        hardSkills={hardSkills}
        userLang={userLang}
        onSkipStep={onSkipStep}
      />
    ),
    [PROFILE_TAB.LANGUAGES]: (
      <LanguagesForm
        member={member}
        onMemberChange={onMemberChange}
        languages={allLanguages}
        onSkipStep={onSkipStep}
      />
    ),
    [PROFILE_TAB.CONTACTS]: (
      <ContactsForm
        member={member}
        onMemberChange={onMemberChange}
        countries={countries}
        _csrf={_csrf}
        vatTypes={vatTypes}
        onSkipStep={onSkipStep}
      />
    ),
    [PROFILE_TAB.MOODS]: (
      <MoodsForm
        member={member}
        onMemberChange={onMemberChange}
        onSkipStep={onSkipStep}
      />
    ),
    [PROFILE_TAB.MEDIA]: (
      <MediaForm
        member={member}
        onMemberChange={onMemberChange}
        onSkipStep={onSkipStep}
      />
    ),
    [PROFILE_TAB.SOCIAL_MEDIA]: (
      <SocialMediaForm
        member={member}
        onMemberChange={onMemberChange}
        onSkipStep={onSkipStep}
      />
    ),
    [PROFILE_TAB.LEGAL_FINANCES]: (
      <LegalFinancesForm
        member={member}
        onMemberChange={onMemberChange}
        vatTypes={vatTypes}
        countries={countries}
        cryptoCurrenciesNetwork={organization.cryptoCurrenciesNetwork || []}
        onSkipStep={onSkipStep}
      />
    ),
    [PROFILE_TAB.PAYMENT]: (
      <PaymentForm cards={cards} onCardsChange={onCardsChange} />
    ),
    [PROFILE_TAB.SETTINGS]: (
      <SettingsForm
        member={member}
        languages={languages}
        currencies={currencies}
        onMemberChange={onMemberChange}
        countries={availableCountries}
        onSkipStep={onSkipStep}
      />
    ),
    [PROFILE_TAB.CONNECTORS]: <Connectors member={member} />,
    [PROFILE_TAB.SIGN_BY_ME]: <DocumentsPanel />,
    [PROFILE_TAB.PERFORMANCE]: (
      <Performance
        stats={stats}
        customTrophies={customTrophies}
        certificates={certificates}
      />
    ),
    [PROFILE_TAB.POSTER]: (
      <Print
        productType={IN_APP_PRODUCT_TYPE.POSTER}
        appProducts={appProducts}
        countries={countries}
        cards={cards}
        onCardsChange={onCardsChange}
      />
    ),
    [PROFILE_TAB.AVAILABILITY]: (
      <div className="tab-pane trainer-tab trainer-availability-tab">
        <TabAvailability
          onMemberChange={onMemberChange}
          userTrainer={member}
          onSkipStep={onSkipStep}
        />
      </div>
    ),
    [PROFILE_TAB.DOCUMENTS]: (
      <TabDocuments
        onMemberChange={onMemberChange}
        organization={organization}
        member={member}
        isInJourney={isInJourney}
        onSkipStep={onSkipStep}
      />
    ),
  };
  return (
    <div ref={ref} className="m-portlet m-portlet--full-height">
      {tabs[activeTab]}
    </div>
  );
});

export default MainPanel;

MainPanel.propTypes = {
  activeTab: PropTypes.oneOf(PROFILE_TABS).isRequired,
  member: PropTypes.shape(UserProp.propType).isRequired,
  userLang: PropTypes.string.isRequired,
  onMemberChange: PropTypes.func.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(StripeCardProp.propType)).isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  availableCountries: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  allLanguages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  currencies: PropTypes.arrayOf(PropTypes.shape(CurrencyProp.propType))
    .isRequired,
  onCardsChange: PropTypes.func.isRequired,
  hardSkills: PropTypes.arrayOf(PropTypes.shape(HardSkillProp.propType))
    .isRequired,
  stats: PropTypes.shape({
    performance: PropTypes.shape(PerformanceProp.propType),
  }).isRequired,
  vatTypes: PropTypes.arrayOf(PropTypes.shape(VatTypesProp.propType))
    .isRequired,
  customTrophies: PropTypes.arrayOf(PropTypes.shape(TrophyProp.propType))
    .isRequired,
  certificates: PropTypes.arrayOf(PropTypes.shape(CertificateProp.propType))
    .isRequired,
  appProducts: PropTypes.arrayOf(PropTypes.shape(AppProductProp.propType))
    .isRequired,
  _csrf: PropTypes.string.isRequired,
  directSellingActive: PropTypes.bool.isRequired,
  workplaceLocations: PropTypes.shape({
    enabled: PropTypes.bool,
    list: PropTypes.arrayOf(AddressProp.propType),
  }).isRequired,
  previousUserPageName: PropTypes.shape({
    error: PropTypes.string,
    userPageName: PropTypes.string,
  }).isRequired,
  organizationCompetenciesDomains: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      _id: PropTypes.string,
    }),
  ),
  organization: PropTypes.shape(organizationProp.propType).isRequired,
  isInJourney: PropTypes.bool,
  onSkipStep: PropTypes.func,
};

MainPanel.defaultProps = {
  organizationCompetenciesDomains: [],
  isInJourney: false,
  onSkipStep: null,
};
